module.exports = __webpack_public_path__ + "img/bg-11.1.c0b34abb.jpg";